import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../services/login.service';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {

  constructor( public router: Router, public loginService:LoginService) { }
 
  public filterText;
  public contact = [];
  public active=[];
  public item=[];
  public reci=[];
 
  
  ngOnInit(): void {
    let collect=JSON.parse(localStorage.getItem('loginUser')).userName
    this.contact = this.loginService.getWorker();
    console.log(this.contact)
    this.contact=this.contact.filter(
      each=> each.userName!==collect
    )
    let message = JSON.parse(localStorage.getItem("reciever"));
    if (message){
        this.reci= message;
    }
    else{
      this.reci=[];
    }
  }
  
  messageReciever(i){

this.loginService.show(true)


if(!localStorage.getItem('messages')){
  localStorage.setItem('messages',JSON.stringify([]))
}

    let receive =   this.contact[i];
    let rec =receive.userName;
    
    let collect=JSON.parse(localStorage.getItem('loginUser')).userName
  console.log(receive)
  this.loginService.rec(receive)
    localStorage.setItem('receiver', JSON.stringify(receive));
let tmsg= JSON.parse(localStorage.getItem('messages'))
let mmm=[];
tmsg.forEach(
  each=>{
    if((each.sender==collect && each.receiver==rec) ||(each.sender==rec && each.receiver==collect)){
if(each.sender==rec){
  each.seen=true
}
    }
  }
)
localStorage.setItem('messages',JSON.stringify(tmsg))
tmsg=tmsg.filter(
  each=> ((each.sender==collect && each.receiver==rec) ||(each.sender==rec && each.receiver==collect) )
)
this.loginService.updateSource(tmsg)
console.log(tmsg)
  }

  logOut(){
    this.router.navigate([`/login`]);
    localStorage.removeItem('loginUser')
  }

}
